export * from './InformationFooter';
